import { render, staticRenderFns } from "./InserirJornalzinho.vue?vue&type=template&id=e68ccd90&scoped=true&"
import script from "./InserirJornalzinho.vue?vue&type=script&lang=js&"
export * from "./InserirJornalzinho.vue?vue&type=script&lang=js&"
import style0 from "./jornalzinho.scss?vue&type=style&index=0&id=e68ccd90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68ccd90",
  null
  
)

export default component.exports